import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteDailyReportEvent(
  uuid: string
): Promise<AxiosResponse<void>> {
  return instance.delete(`/daily-report/event/${uuid}`)
}
